/**
 * @author gyb(mocheer)
 * @since 2016.11.4
 * 
 * @see https://github.com/Leaflet/Leaflet/issues/2553
 * @see https://github.com/htoooth/Leaflet.ChineseTmsProviders
 * @see https://github.com/mylen/leaflet.TileLayer.WMTS
 * @see https://github.com/ywqyunshan/LeafletGIS/blob/fe6f2a323f0903f29c1a6db7fef76b2c29909dc9/js/page_mapload_customcrs.js
 * @see https://github.com/za59418/TestLeaflet/blob/a6c15d34766130440eea6599be7aa610b23987d1/projects/LeafletClient/lib/leaflet/CRS2379.js
 */
import basemapOptions from "./provider/BasemapOptions";
import TencentMap from './provider/TencentMap';
import DMap from './provider/DMap';
import WMTSLayer from "./layer/WMTSLayer";
// import BaiduMap from './provider/BaiduMap';
//
let {
  assign: $assign,
  isArray
} = T;
let {
  TileLayer,
  CRS,
  layerGroup: toLayerGroup
} = L;
/**
 * 地图瓦片图层服务
 */
export default class Provider extends L.LayerGroup {
  name;
  zoom;
  /**
   * 更新crs
   */
  setCRS(crs) {
    if (!crs) return;
    if (typeof crs === 'string') {
      crs = CRS[crs];
    }
    let {
      _map: map
    } = this;
    let {
      options
    } = map;
    let zoom = this.zoom || map.getZoom();
    //
    // 
    if (map && options.crs !== crs) {
      let center = map.getCenter();
      // zoom += (crs === CRS.EPSG4326) ? -1 : 1;//待修改 zoomOffset
      options.crs = crs;
      //
      map.setView(center, zoom); // 改变 crs 会改变中心点
      map._resetView(center, zoom += ((crs === CRS.EPSG4326) ? -1 : 1), true); // 重新绘制要素图层
    }
  }
  /**
   * 
   * @param options 
   * 1、string privder              GaodeMap.Normal
   * 2、{options,url}               {url,options:{zoomOffset,minZoom}}
   * 3、object {crs,name,provider}  {crs:'EPSG3857',provider:{}}
   * 4、array []
   */
  addLayers(options) {
    let groups;

    if (isArray(options)) {
      let overGroups;
      groups = options.map(config => {
        let name = config;
        let url = '';
        let options = null;
        if (typeof name === 'object') {
          name = config.name;
          url = config.url;
          options = config.options;
          if (config.overZoom) { //极限图包
            this.overZoom = true;
            let {
              overZoom
            } = config;
            if (overZoom) {
              overZoom = overZoom.split(',');
              let limitZoom = overZoom[0];
              overGroups = overZoom.slice(1).map(zoom => {
                let cloneOptions = T.clone(options || {});
                cloneOptions.tileSize = 512 * (zoom - limitZoom);
                cloneOptions.minZoom = cloneOptions.maxZoom = zoom;
                cloneOptions.zoomOffset = (cloneOptions.zoomOffset || 0) - (zoom - limitZoom);
                return this.create(name, url, cloneOptions)
              })
            }
          }
        }
        return this.create(name, url, options)
      });
      if (overGroups) {
        groups = groups.concat(overGroups);
      }
    } else {
      if (typeof options === 'string' || !options.provider) {
        this.name = options;
        return this.addLayers([options]);
      } else { //  {crs:'EPSG3857',provider:{}}
        options.crs && this.setCRS(options.crs);
        this.name = options.name;
        return this.addLayers(options.provider || options);
      }
    }
    let layers = toLayerGroup(groups);
    this.addLayer(layers);
    //
    return layers;
  }
  /**
   * 
   * @param options 
   */
  updateLayers(options) {
    this.zoom = this._map._zoom;
    this._providerOptions = options; // 用于成图，用于二三位一体化
    this.clearLayers();
    if (this.overZoom) { // todo 待完善
      this.overZoom = false;
      console.log(`警告：当前图包的层级${this.zoom}在清除之后变为${this._map._zoom}`)
      console.log('正在修复..')
      setTimeout(() => {
        console.log('修复层级为：', this.zoom);
        this._map._animatingZoom = false;
        // 不能用setZoom，因为panOptions有动画，可能连中心点都发生了变化
        this._map.setView(this._map.getCenter(), this.zoom, {
          animate: false
        })
        console.log(`修复完毕，当前层级为：${this._map._zoom}`)
      }, 0)
    }
    // 当 crs == CRS.EPSG4326 时 , 清除图层后获取到 zoom 为之前图层的最大层级(一般是18)  -----  这个在现在的版本验证没有这个问题
    return this.addLayers(options); // clearLayer 极限图包中会造成zoom异常
  }
  /**
   * 
   * @param options 
   * { name: 'DMap', options: { url: 'http://192.168.118.226:50024/WebApi/api/v1/map/tile/local?id={id}&name=wz' } }
   * 'GaodeMap.Normal'
   */
  create(name, url, options) {
    let {
      _map: map
    } = this;
    let {
      options: mapOptions
    } = map;
    let Layer = TileLayer;

    if (name) {
      let basemap = basemapOptions[mapOptions.crs.code.replace(':', '')];
      if (!basemap) {
        console.warn('不存在图包:' + name);
        return;
      }
      let parts = name.split('.');
      let providerName = parts[0];
      let src = basemap[providerName];
      switch (providerName) {
        case 'TencentMap':
          Layer = TencentMap;
          break;
        case 'DMap':
          Layer = DMap;
          break;
        case 'WMS':
          Layer = TileLayer.WMS;
          break;
        case 'WMTS':
          Layer = WMTSLayer;
          break;
      }
      if (src) {
        let {
          options: defaultOptions
        } = src;
        let variantName = parts[1];
        // 变化v -> variants
        if (variantName) {
          let variant = src.v[variantName];
          let vo;
          if (typeof variant === 'string') {
            vo = {
              v: variant
            };
          } else {
            url = url || variant.url;
            vo = variant.options;
          }
          defaultOptions = $assign({}, defaultOptions, vo)
        }
        url = url || src.url;
        options = $assign({}, defaultOptions, options)
      }
    }
    return new Layer(url, options);
  }
}



// WEBPACK FOOTER //
// ./src/Provider.js